export default __webpack_public_path__ + "static/media/alumni_project.4efa2b41.JPG";